export enum DashboardTranslKey {
    DASHBOARD = "dashboard:dashboard",
}